import React, { useEffect, useState } from 'react'
import { Box, TextField } from '@mui/material'
import {
  DevEmailSettings,
  getDevEmailSettings,
  setDevEmailCounter,
  setDevEmailFirstName,
  setDevEmailLastName,
} from 'src/legacy/components/addParticipantForms/getDevEmail'

type Props = {
  refreshKey: number
}

// For development purposes only.
export function DevEmailSettingsFields({ refreshKey }: Props) {
  const [settings, setSettings] = useState<DevEmailSettings>(() => getDevEmailSettings())

  useEffect(() => {
    setSettings(getDevEmailSettings())
  }, [refreshKey])

  const handleFirstNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const firstName = event.target.value
    setSettings((current) => ({ ...current, firstName }))
    setDevEmailFirstName(firstName)
  }

  const handleLastNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const lastName = event.target.value
    setSettings((current) => ({ ...current, lastName }))
    setDevEmailLastName(lastName)
  }

  const handleCounterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const counter = event.target.value

    if (!/^\d*$/.test(counter)) {
      return
    }

    setSettings((current) => ({ ...current, counter }))
    setDevEmailCounter(counter)
  }

  return (
    <Box display="flex" flexWrap="wrap" gap={1} alignItems="flex-start">
      <TextField
        label="Autofill first name"
        onChange={handleFirstNameChange}
        size="small"
        sx={{ width: 180 }}
        value={settings.firstName}
      />
      <TextField
        label="Autofill last name"
        onChange={handleLastNameChange}
        size="small"
        sx={{ width: 180 }}
        value={settings.lastName}
      />
      <TextField
        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
        label="Email counter"
        onChange={handleCounterChange}
        size="small"
        sx={{ width: 140 }}
        value={settings.counter}
      />
    </Box>
  )
}
